import React from "react";
import axios from "axios";
import { t } from "../../localization/localization";

import { Row, Container } from "react-bootstrap";
import { Pie } from "react-chartjs-2";

export default class EnCokAtif extends React.Component {
  state = {
    data: [],
    chartTitlesWithLocalization: [],
    enCokAtifRowSetting: "",
  };

  EN_COK_ATIF_ROW_TYPES = [
    {
      type: "MATERIALIZED_VIEW",
      showLegend: true,
    },
    {
      type: "ORGANIZATION_MATERIALIZED_VIEW",
      showLegend: false,
    },
    {
      type: "EXTERNAL_SCOPUS",
      showLegend: true,
    },
  ];

  componentDidMount() {
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/report/enCokAtif`)
      .then((res) => {
        const chartTitlesWithLocalization =
          res.data.chartTitlesWithLocalization;
        const enCokAtifRows = res.data.enCokAtifRows.map((e) => ({
          label: e.name,
          data: e.metriccount,
        }));

        const enCokAtifRowSetting = this.EN_COK_ATIF_ROW_TYPES.find(
          (item) => item.type === res.data?.enCokAtifType
        );
        this.setState({
          data:
            enCokAtifRows.length > 10
              ? enCokAtifRows.slice(0, 10)
              : enCokAtifRows,
          chartTitlesWithLocalization: chartTitlesWithLocalization,
          enCokAtifRowSetting: enCokAtifRowSetting,
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    const paletteName = urlSearchParams.get("palette");
    return (
      <Container>
        <Row>
          <h4>{t(locale, "/home/enCokAtif/title")}</h4>
          <div
            style={{
              fontSize: "14px",
              color: "gray",
              textDecoration: "underline",
              width: "100%",
            }}
          >
            ({this.state.chartTitlesWithLocalization[locale === "tr" ? 0 : 1]})
          </div>
        </Row>
        <Row>
          <Pie
            data={{
              labels: this.state.data.map((e) => e.label),
              datasets: [
                {
                  label: t(locale, "/home/enCokAtif/title"),
                  data: this.state.data.map((e) => e.data),
                  backgroundColor: generateColors(
                    this.state.data.length,
                    paletteName
                  ),
                  hoverBackgroundColor: generateColors(
                    this.state.data.length,
                    paletteName
                  ),
                },
              ],
            }}
            width={440}
            height={290}
            options={{
              title: t(locale, "/home/enCokAtif/title"),
              maintainAspectRatio: false,
              plugins: {
                datalabels: {
                  color: "white",
                },
              },
              legend: {
                display: this.state.enCokAtifRowSetting?.showLegend,
              },
            }}
          />
        </Row>
      </Container>
    );
  }
}

const PALETTE = {
  cold: ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"],
};

function generateColors(count, paletteName) {
  var palette;
  if (!PALETTE[paletteName]) {
    palette = PALETTE["cold"];
  } else {
    palette = PALETTE[paletteName];
  }
  var colors = [];
  for (var i = 0; i < count; i++) {
    colors.push(palette[i % palette.length]);
  }
  return colors;
}
